// Réglages du registre des dossiers (Paramètres › Dossiers).

export const REGISTRY_FILTER_KEYS = ['type', 'frise', 'lead', 'jur', 'ech'] as const;
export type RegistryFilterKey = (typeof REGISTRY_FILTER_KEYS)[number];

export const REGISTRY_FILTER_LABELS: Record<RegistryFilterKey, string> = {
  type: 'Type de dossier',
  frise: 'Type d’affaire',
  lead: 'Responsable',
  jur: 'Juridiction',
  ech: 'Échéance',
};

export type DossierRegistrySettings = {
  /** Vue en colonnes (kanban) proposée. */
  board: boolean;
  filters: RegistryFilterKey[];
};

export const DEFAULT_REGISTRY_FILTERS: RegistryFilterKey[] = ['type', 'lead', 'jur', 'ech'];

export const DEFAULT_DOSSIER_REGISTRY_SETTINGS: DossierRegistrySettings = {
  board: false,
  filters: DEFAULT_REGISTRY_FILTERS,
};

export function parseRegistryFilters(value: unknown): RegistryFilterKey[] {
  if (!Array.isArray(value)) return DEFAULT_REGISTRY_FILTERS;
  return REGISTRY_FILTER_KEYS.filter((key) => value.includes(key));
}

export function parseDossierRegistrySettings(input: {
  board?: unknown;
  filters?: unknown;
}): DossierRegistrySettings {
  return {
    board: input.board === true,
    filters: parseRegistryFilters(input.filters),
  };
}
